import { render, staticRenderFns } from "./DsNoticia.vue?vue&type=template&id=207f6d9f&scoped=true"
import script from "./DsNoticia.vue?vue&type=script&lang=js"
export * from "./DsNoticia.vue?vue&type=script&lang=js"
import style0 from "./DsNoticia.vue?vue&type=style&index=0&id=207f6d9f&prod&scoped=true&lang=css"
import style1 from "./DsNoticia.vue?vue&type=style&index=1&id=207f6d9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f6d9f",
  null
  
)

export default component.exports